module.exports = __webpack_public_path__ + "static/media/chat_logo.2b09b2ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat_logo.svg
// module id = 6852
// module chunks = 0